<template>
  <div class="scmcc-first-page-manage">
    <div class="title-style">
      <span class="content-style theme-border-primary-color">自定义首页管理</span>
      <Button
        class="button-style"
        type="primary"
        icon="md-add"
        stype="primary"
        @click="addFirstPage"
      >添加自定义首页</Button>
    </div>
    <div style="position:relative;">
      <Spin fix size="large" v-if="loading"></Spin>
      <Table class="table-style" :columns="columns" :data="columnsData" stripe>
        <template slot-scope="{ row }" slot="action">
          <Tooltip :delay="3000">
            <CIcon
              icon="tongyong-bianji"
              handleColor="default"
              class="icon_1"
              @click="editPage(row.id,row.moduleIds,row.indexName)"
              style="cursor:pointer;margin-right: 5px"
              size="16"
            />
            <div slot="content">编辑</div>
          </Tooltip>
          <Tooltip :delay="3000" v-if="row.defaultIndex == 0">
            <CIcon
              icon="tongyong-fenpei"
              handleColor="default"
              class="icon_1"
              @click="configMember(row.indexName, row.id)"
              style="cursor:pointer;margin-right: 5px"
              size="16"
            />
            <div slot="content">分配</div>
          </Tooltip>
          <Tooltip :delay="3000" v-if="row.defaultIndex == 0">
            <Poptip
              word-wrap
              confirm
              title="是否确认删除已选自定义首页?"
              placement="top"
              transfer
              @on-ok="deletePage(row.id)"
            >
              <CIcon
                icon="tongyong-shanchu"
                handleColor="delete"
                class="icon_1"
                style="cursor:pointer"
                size="16"
              />
            </Poptip>
            <div slot="content">删除</div>
          </Tooltip>
        </template>
      </Table>
    </div>

    <!-- 后续如果需要添加分页，则放开该注释代码 -->
    <!-- <Page class="page-style" :current="pageNum" :total="totalLength" show-total show-elevator 
              show-sizer @on-change="changePageNum" @on-page-size-change="changePageSize" :page-size-opts="pageSizeSet"
              placement="bottom">
    </Page>-->
    <FirstPageConfig ref="firstPageConfig"></FirstPageConfig>
    <MemberConfig ref="memberConfig"></MemberConfig>
  </div>
</template>

<script>
import FirstPageConfig from './FirstPageConfig'
import MemberConfig from './memberConfig'
export default {
  components: { FirstPageConfig, MemberConfig },
  name: '/settings/homeManage',
  data() {
    return {
      isAdd: false,
      pageMessage: '111',
      pageNum: 1,
      pageSize: 10,
      totalLength: 0,
      columnsData: [],
      loading: true,
      columns: [
        {
          title: '自定义首页名称',
          key: 'indexName',
          render: (h, params) => {
            if (params.row.defaultIndex == 1) {
              return h('div', [
                h('span', params.row.indexName),
                h(
                  'span',
                  {
                    props: { type: 'text', size: 'small' },
                    attrs: {
                      disabled: true
                    },
                    class: 'theme-font-primary-color',
                    style: {
                      marginLeft: '5px',
                      width: '44px',
                      backgroundColor: '#EAF0F8',
                      borderRadius: '16px',
                      display: 'inline-block',
                      padding: '2px',
                      textAlign: 'center'
                    }
                  },
                  '默认'
                )
              ])
            } else {
              if (params.row.indexName.length > 5) {
                return h('div', [
                  h(
                    'Tooltip',
                    {
                      props: {
                        placement: 'top-start',
                        content: params.row.indexName,
                        transfer: true,
                        maxWidth: '220'
                      }
                    },
                    [h('span', params.row.indexName.substring(0, 5) + '...')]
                  )
                ])
              } else {
                return h('div', params.row.indexName)
              }
            }
          }
        },
        {
          title: '创建人',
          key: 'creatorName'
        },
        {
          title: '创建时间',
          key: 'createDate',
          render: (h, params) => {
            return h('div', this.getTaskTime(params.row.createDate))
          }
        },
        {
          title: '使用人数',
          key: 'useCount',
          align: 'right',
          render: (h, params) => {
            return h('div', params.row.useCount)
          }
        },
        {
          title: '操作',
          slot: 'action'
        }
      ]
    }
  },
  mounted() {
    this.queryFirstPageList()
  },
  created() {},
  methods: {
    getTaskTime(strDate) {
      if (null == strDate || '' == strDate) {
        return ''
      }
      var dateStr = strDate.trim().split(' ')
      var strGMT =
        dateStr[0] +
        ' ' +
        dateStr[1] +
        ' ' +
        dateStr[2] +
        ' ' +
        dateStr[5] +
        ' ' +
        dateStr[3] +
        ' GMT+0800'
      var date = new Date(Date.parse(strGMT))
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      var second = date.getSeconds()
      second = second < 10 ? '0' + second : second

      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    addFirstPage() {
      this.$refs.firstPageConfig.openFirstPageConfig(true)
    },

    //查询首页列表
    queryFirstPageList() {
      this.loading = true
      //重新传染人员树
      //拿到总数目totalLength
      this.$http.get('/sctm/customindex/getCustomIndexList').then(res => {
        console.log('首页列表总数', res.data)
        if (res.data.returnCode == 0) {
          this.columnsData = res.data.beans
        } else {
          this.$Message.error(res.data.returnMessage)
        }
        this.loading = false
      })
    },
    //编辑首页
    editPage(data1, data2, data3) {
      this.$refs.firstPageConfig.openFirstPageConfig(false, data1, data2, data3)
    },

    //删除首页
    deletePage(data) {
      this.$http
        .get('/sctm/customindex/dropCustomIndexById', { params: { id: data } })
        .then(res => {
          if (res.data.returnCode == 0) {
            this.queryFirstPageList()
          } else {
            this.$Message.error(res.data.returnMessage)
          }
        })
    },

    //分配人员
    configMember(data1, data2) {
      this.$refs.memberConfig.openMemberConfig(data1, data2)
    },
    //页码改变时的回调
    changePageNum(num) {
      this.pageNum = num
      this.queryFirstPageList()
    },
    //切换每页条数时的回调，返回切换后的每页条数
    changePageSize(size) {
      this.pageSize = size
      this.queryFirstPageList()
    }
  }
}
</script>


<style lang="less">
.scmcc-first-page-manage {
  background: #fff;
  border-radius: 6px;
  padding: 0 24px;
  margin-bottom: 20px;
  min-width: auto;
  .title-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 24px;
    color: #33344a;
    font-size: 18px;
    line-height: 1;
    font-weight: 700;
    .content-style {
      border-left-width: 4px;
      border-left-style: solid;
      padding-left: 9px;
    }
  }
  .button-style {
    float: right;
    font-size: 14px;
  }
  .table-style {
    margin-bottom: 20px;
  }
  .page-style {
    margin-bottom: 20px;
    text-align: center;
  }
}
</style>
